const removeOrphans = (text: string): string => {
  return text.replace(/(\s)([\S])[\s]+/g, "$1$2&nbsp;")
}

export default removeOrphans